module.exports = __webpack_public_path__ + "static/img/id-card.1eb10de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/id-card.png
// module id = EAlt
// module chunks = 10